<template>
	<div class="section">
		<div class="container">
			<div class="blog-pagination">
				<template v-for="i in max_num_pages">
					<router-link
						:key="i"
						v-if="paginationNumsToShow.includes(i)"
						:class="{ selected: page == i }"
						:to="{
							name: pathName,
							params: {
								tagSlug: decodeURI(tagSlug),
								page: i,
								noScroll: true,
							},
						}"
						@click.native="test"
					>
						{{ i }}
					</router-link>
					<a class="dots" v-else>...</a>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {};
		},
		props: {
			current_page: {
				type: Number,
				default: 1,
			},
			max_num_pages: {
				type: Number,
				default: 1,
			},
			page: {
				type: Number,
				default: 1,
			},
			tagSlug: {
				type: String,
				default: "",
			},
		},
		created() {},
		mounted() {},
		computed: {
			pathName() {
				if (this.tagSlug) {
					return "blog-posts-by-tag-page";
				}
				return "blog-posts-main-page";
			},
			paginationNumsToShow() {
				let nums = [1];
				const page = parseInt(this.page);
				if (page > 1) {
					nums.push(page - 1);
				}
				nums.push(page);
				if (page < this.max_num_pages) {
					nums.push(page + 1);
				}
				nums.push(this.max_num_pages);
				nums = [...new Set(nums)];
				if (nums.at(1) !== 2) {
					nums.splice(1, 0, "...");
				}
				if (nums.at(-2) !== this.max_num_pages - 1) {
					nums.splice(-1, 0, "...");
				}
				return nums;
			},
		},
		watch: {},
		methods: {
			test() {
				const id = "profilePhoto";
				const yOffset = -120;
				const element = document.getElementById(
					"scroll-after-pagination-nav"
				);
				const y =
					element.getBoundingClientRect().top +
					window.pageYOffset +
					yOffset;
				window.scrollTo({ top: y, behavior: "smooth" });
			},
		},
		components: {},
	};
</script>

<style lang="sass" scoped>
	$grey1: #f7f7f7
	$grey2: #eaeaea
	$red: #ea4725
	$white: #ffffff
	$black: #000000
	$dark: #213519
	$green: #cbe5c0

	.section
		background-color: $white

	.blog-pagination
		display: flex
		padding: 2rem 0
		gap: 0.25rem
		justify-content: center
		direction: ltr

		a
			display: block
			padding: 0.5rem
			color: $dark
			border-radius: 0.25rem
			width: 2.5rem
			border: 1px solid $grey2
			text-align: center
			&:focus, &:hover
				background-color: $green

		a.selected
			background-color: $dark
			color: $green

	.dots
		cursor: not-allowed
	.dots + .dots
		display: none
</style>
